// 定义一个表示成功的右勾图标的函数组件
const RightSuccess = ({ ...props }) => {
  // 返回SVG图标
  return (
    <svg
      // 设置SVG的命名空间
      xmlns="http://www.w3.org/2000/svg"
      // 设置图标宽度
      width="64"
      // 设置图标高度
      height="64"
      // 设置视图框大小
      viewBox="0 0 64 64"
      // 默认不填充颜色
      fill="none"
      // 展开传入的props属性
      {...props}
    >
      {/* // 绘制一个圆形作为图标的背景 */}
      <circle cx="32" cy="32" r="32" fill="#52C41A" />
      {/* // 绘制一个勾形路径 */}
      <path
        // 设置填充规则
        fillRule="evenodd"
        // 设置剪切规则
        clipRule="evenodd"
        // 定义路径的d属性
        d="M47.6232 22.0646C46.649 21.0904 45.0696 21.0904 44.0954 22.0646L28.6351 37.5249L19.1921 28.0819C18.2179 27.1078 16.6384 27.1078 15.6642 28.0819C14.69 29.0561 14.69 30.6356 15.6642 31.6098L26.6628 42.6084C26.6979 42.6434 26.7337 42.6772 26.7703 42.7097C26.8026 42.7461 26.8363 42.7818 26.8712 42.8167C27.8454 43.7909 29.4248 43.7909 30.399 42.8167L47.6232 25.5925C48.5974 24.6183 48.5974 23.0388 47.6232 22.0646Z"
        // 设置填充颜色为白色
        fill="white"
      />
    </svg>
  )
}

// 导出RightSuccess组件
export default RightSuccess
